import Alpine from "alpinejs";

const data = (params = {}) => ({
  /**
   *  Data
   */
  checkedList: [],
  storageKey: '',
  /**
   *  Targets
   */
  /**
   *  Main & Event Callback
   */

  init() {
    this.storageKey = `checkedList_${window.location.pathname}`;

    const storedCheckedList = sessionStorage.getItem(this.storageKey);
    if (storedCheckedList && storedCheckedList.length > 0) {
      this.checkedList = JSON.parse(storedCheckedList);
      this.showCompareSection = true
    } else {
      this.showCompareSection = false
    }
    this.checkedListChange()
    this.updateCheckboxes()
  },
  checkedListChange() {
    this.$watch('checkedList', value => {
      if(value.length > 0) {
        this.showCompareSection = true
        sessionStorage.setItem(this.storageKey, JSON.stringify(value));
      } else {
        this.showCompareSection = false
        sessionStorage.removeItem(this.storageKey);
      }
    })
  },
  checkboxChange(id) {
    if (this.checkedList.includes(id)) {
      this.checkedList = this.checkedList.filter(v => v !== id)
    } else {
      if (this.checkedList.length < 5) {
        this.checkedList.push(id)
      } else {
        alert('※比較対象は最大五個まで')
        this.$event.target.checked = false
      }
    }
  },
  updateCheckboxes() {
    const storedCheckedList = sessionStorage.getItem('checkedList');
    if (storedCheckedList) {
      this.checkedList = JSON.parse(storedCheckedList);
    }

    this.$nextTick(() => {
      const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = this.checkedList.includes(checkbox.value);
      });
    });
  },
  ...params
})

Alpine.data('checkboxList', data)
export default data
